<template>
  <div ref="chart" :style="{height, width}" />
</template>

<script>
import {debounce} from "@/utils/visual";

export default {
  name: "flowCurrent",
  props: {
    chartData1:{
      type: String,
      require: true
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '950px'
    },
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    window.removeEventListener('resize', this.__resizeHandler)
    this.chart.dispose()
    this.chart = null
  },
  methods:{
    initChart() {
        this.chart = this.$echarts.init(this.$refs.chart)
        this.setOptions()
    },
    setOptions() {
          let option = {
            title: {
              text: '水文站1',
              textStyle:{
                //文字颜色
                color:'#ccc',
                //字体风格,'normal','italic','oblique'
                fontStyle:'normal',
                //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
                fontWeight:'bold',
                //字体系列
                fontFamily:'sans-serif',
                //字体大小
                fontSize:18
              }
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                crossStyle: {
                  color: 'rgb(6,161,250)'
                },
                label: {
                  backgroundColor: 'rgb(6,161,250)'
                }

              }
            },
            legend: {
              data: ['实测流量'],
              textStyle: {
                color: 'rgb(6,161,250)' // 设置字体颜色为红色
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              feature: {
                dataView: {show: true, readOnly: false},
                magicType: {show: true, type: ['line', 'bar']},
                restore: {show: true},
                saveAsImage: {show: true}
              }
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              axisTick: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  color: '#4682B4'
                },
              },
              data: ["0:00", "1:00",  "2:00",  "3:00",  "4:00", "5:00",  "6:00", "7:00", "8:00", "9:00", "10:00", "11:00", "12:00"]
            },
            yAxis: {
              name: '流量(m^3/s)',
              type: 'value',
              min:0,  //取0为最小刻度
              max: 1400, //取100为最大刻度
              // boundaryGap: [0, '100%'],
              splitLine: {
                show: false
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#4682B4'
                }
              }
            },
            series: [
              {
                name: '实测流量',
                type: 'line',
                smooth: true,
                symbolSize: 1,//去掉页面上显示的圆点
                itemStyle: {
                  normal: {
                    color: "#00FFFF",
                    lineStyle: {
                      color: "#00FFFF",
                    },
                  },
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#00FFFF'//下层渐变
                    }, {
                      offset: 0.8,
                      color: 'rgba(137, 189, 27, 0)'
                    }], false),
                    shadowColor: 'rgba(0, 0, 0, 0.1)',
                    shadowBlur: 10
                  }
                },
                data: [30, 142, 361, 474, 900, 630, 508,null,null,null,null,null,null],
                lineStyle: { // 设置线条的style等
                  normal: {
                    color: '#00BFFF', // 折线线条颜色:红色
                  },
                },
              },
            ]
          };

      this.chart.setOption(option, true);
    }
  },
  watch: {
    chartData() {
      this.setOptions()
    }
  }
}
</script>

<style scoped>

</style>